import {AgencyRepositoryType} from "../../interfaces/repositories/AgencyRepositoryType.ts";
import {TripbookPackage} from "../../entities/Agency.ts";

export class UpdateAgencyPackageUseCase {
    constructor(private readonly agencyRepository: AgencyRepositoryType) {}

    execute(agencyId: string, packageId: string, unitPrice: number, quantity: number, date: number, numberOfPagesIncluded?: number): Promise<TripbookPackage> {
        return this.agencyRepository.updateAgencyPackage(agencyId, packageId, unitPrice, quantity, date, numberOfPagesIncluded)
    }
}

